function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState } from 'react';
import { InfoIcon } from '@domain-group/fe-co-icon';
import { Tooltip } from '@domain-group/fe-blueprint-ui/tooltip';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './listing-info-pill.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var InfoTooltip = _ref => {
  var infoText = _ref.infoText,
    onVisibleChange = _ref.onVisibleChange,
    children = _ref.children;
  return infoText ? ___EmotionJSX(Tooltip, {
    onVisibleChange: onVisibleChange,
    placement: "top",
    content: infoText
  }, children) : children;
};
export var ListingInfoPill = _ref2 => {
  var icon = _ref2.icon,
    label = _ref2.label,
    details = _ref2.details,
    ctaIcon = _ref2.ctaIcon,
    infoText = _ref2.infoText,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'neutral' : _ref2$color,
    className = _ref2.className;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var popupShown = useRef(false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTooltipVisible = _useState2[0],
    setTooltipVisible = _useState2[1];
  var handleShowPopup = visible => {
    setTooltipVisible(visible);
    if (visible && !popupShown.current) {
      popupShown.current = true;
      sendEvent('pill-info-shown');
    }
  };
  return ___EmotionJSX(InfoTooltip, {
    infoText: infoText,
    onVisibleChange: handleShowPopup
  }, ___EmotionJSX("div", {
    css: styles.pill(isTooltipVisible, color),
    className: className
  }, icon, label && ___EmotionJSX("span", {
    css: styles.label
  }, label), details && ___EmotionJSX("span", {
    css: styles.value
  }, details), ctaIcon || ___EmotionJSX(InfoIcon, {
    size: "small"
  })));
};